<template>
    <div :class="wrapper">
        <div v-if="isAdmin"
            :class="{ 'text-sm' : small, 'text-xl py-1' : !small }"
            class="bg-yellow-200 text-center leading-5 font-medium text-gray-800"
        >
            <span> ADMIN </span>
        </div>
        <div v-else-if="isLocal"
            :class="{ 'text-sm' : small, 'text-xl py-1' : !small }"
            class="bg-yellow-200 text-center leading-5 font-medium text-gray-800"
        >
            <span> LOCAL </span>
        </div>
        <div v-else
            :class="{ 'bg-green-200' : userSupport || (orgCode && onlyOrg), 'bg-red-200' : !userSupport || (!orgCode && onlyOrg), 'text-sm' : small, 'text-xl py-1' : !small }"
            class="text-center leading-5 font-medium text-gray-800 select-all"
        >
            <span>
                {{ orgCode ?? '?????' }}
            </span>
            <span v-if="!onlyOrg" class="font-bold text-gray-600 select-none">
                -
            </span>
            <span v-if="!onlyOrg">
                {{ userCode ?? '??' }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "support-code",
    props: {
        orgCode: {
            type: String,
            default: null
        },
        userSupport: {
            type: Boolean,
            default: false
        },
        userCode: {
            type: String,
            default: null
        },
        isLocal: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        onlyOrg: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false
        },
        wrapper: {
            type: String,
            default: ''
        }
    }
}
</script>
